const hostsToRedirect = ['ccp.dev.kitopiconnect.com', 'ccp.stage.kitopiconnect.com'];

if (hostsToRedirect.includes(window.location.host)) {
  window.location.replace(window.location.href.replace('kitopiconnect.com', 'kitopi-internal.com'));
}
